/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CardC from "../../../components/CustomCard/CardC";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Loader, toaster } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import Form from "./Form";
import { Button } from "react-bootstrap";
import createURL from "../../../libs/peticiones/url";
import { checkPermission } from "../../../libs/menuPermissions/permissions";
import { useStore } from "../../../context/AppContext";
import { Area } from "../../../types/compl-archivos/Area";
import { Instancia } from "../../../types/compl-archivos/Instancia";
import { Distrito } from "../../../types/compl-archivos/Distrito";
import Datatable from "../../../components/Datatable/Datatable";
import { Region } from "../../../types/compl-archivos/Region";

export default function Areas() {
    const [loading, setLoading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<Area | undefined>();
    const [instancias, setInstancias] = useState<Instancia[]>([]);
    const { state } = useStore();

    useEffect(() => {
        getInstancias();
    }, []);

    async function getInstancias() {
        const res = await peticionBack({}, "/instancias", "GET", false, toaster);
        if (res) setInstancias(res.data);
        setLoading(false);
    }
    async function getData(order: string, records: number, page: number, search: string) {
        const url = createURL("/areas", [
            { name: "order", value: order },
            { name: "records", value: records },
            { name: "page", value: page },
            { name: "search", value: search },
            { name: "populate", value: "instance,district,p_area" },
            { name: "rows", value: "_id,name,area_key,email,p_area,district,instance" },
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        return res;
    }

    /* TABLA */
    const columns = [
        { data: "name", render: (n: string) => <p>{n}</p> },
        { data: "area_key" },
        { data: "instance", render: (i: Instancia) => <p>{i.name}</p>, orderValue: "instance.name" },
        { data: "district", render: (d: Distrito) => <p>{d ? d.name : ""}</p>, orderValue: "district.name" },
        { data: "p_area", render: (a: any) => <p>{a?.name || a}</p> },
        {
            data: null,
            render: (row: Area) => (
                <div className="d-flex justify-content-evenly">
                    {checkPermission(state, "update") && <FontAwesomeIcon icon={faPencil} className="text-warning cursor-pointer" onClick={() => openToEdit(row)} />}
                    {checkPermission(state, "delete") && (
                        <FontAwesomeIcon icon={faTrashCan} className="text-danger cursor-pointer" onClick={() => swalAction(deleteRow, "Eliminar Área", `¿Desea eliminar la área ${row.name}?`, "question", row._id, "Eliminar")} />
                    )}
                </div>
            ),
        },
    ];

    const columnDefs = [
        { orderable: false, targets: [5] },
        { className: "text-center", targets: [1, 5] },
    ];

    async function deleteRow(id: number) {
        setLoading(true);
        const res = await peticionBack({}, `/areas/${id}`, "DELETE", true, toaster);
        if (res) setRefresh(true);
        setLoading(false);
    }

    function openToEdit(row: Area) {
        setSelected(row);
    }

    useEffect(() => {
        if (selected) setOpen(true);
    }, [selected]);

    useEffect(() => {
        if (!open) {
            if (selected) setSelected(undefined);
        }
    }, [open]);

    return (
        <CardC>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Áreas {open && (selected ? "- Editar" : "- Agregar")}</h4>
                {!open && checkPermission(state, "create") && (
                    <Button onClick={() => setOpen(true)} className="my-1 my-md-0">
                        Agregar
                    </Button>
                )}
            </div>
            {open ? (
                <Form setOpen={setOpen} selected={selected} instancias={instancias} />
            ) : (
                checkPermission(state, "read") && (
                    <Datatable columns={columns} headers={["Nombre", "Clave", "Instancia", "Distrito", "A. Padre", "Acciones"]} columnDefs={columnDefs} petition={getData} control="back" stateRefresh={[refresh, setRefresh]} className="p-0" />
                )
            )}
            {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
        </CardC>
    );
}
